import React, { useId, useState, ChangeEventHandler } from 'react';
import Image from 'next/image';

import {
  TextInputWrapper,
  InputLabel,
  SelectInput,
  ErrorMessage,
  IconWrapper
} from './style';

import { BaseInputProps, TextInputWidth } from '../shared';

import icon from '@/images/error_icon.svg';

interface TextInputProps extends BaseInputProps {
  options: { key: string; value: string }[];
  handleOnChange: ChangeEventHandler<HTMLSelectElement>;
}

export function Select({
  options,
  value,
  type,
  label,
  error,
  required,
  handleOnChange,
  disabled = false,
  width = TextInputWidth.FULL
}: TextInputProps) {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const inputId = useId();

  return (
    <>
      <TextInputWrapper width={width} error={!!error}>
        <InputLabel htmlFor={inputId} floatLabel={!!value || isFocused}>
          {label}
          {required ? '*' : ''}
        </InputLabel>
        <SelectInput
          data-testid={`select-${type}-${label}`}
          onChange={handleOnChange}
          required={required}
          disabled={disabled}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
        >
          {options.map((option) => (
            <option key={option.key}>{option.value}</option>
          ))}
        </SelectInput>
      </TextInputWrapper>
      <ErrorMessage
        data-testid={`input-${type}-${label}-error`}
        visible={!!error}
      >
        <IconWrapper>
          <Image src={icon} alt="error icon" />
        </IconWrapper>
        {error || ''}
      </ErrorMessage>
    </>
  );
}
